import { Box, BoxProps, styled } from '@mui/material';

interface CustomDividerProps extends BoxProps {
  arrow?: boolean;
  arrowSize?: number;
}

export const CustomDivider = styled(
  ({ arrow, arrowSize, ...rest }: CustomDividerProps) => <Box {...rest} />,
)(({ theme, arrowSize = 10, arrow }) => ({
  height: 1,
  flexGrow: 1,
  transform: 'translateX(0)',
  '&::before': {
    content: arrow ? '""' : undefined,
    height: arrowSize,
    width: arrowSize,
    position: 'absolute',
    right: 0,
    top: `50%`,
    borderTop: `${arrowSize * 0.25}px solid ${theme.palette.secondary.main}`,
    borderRight: `${arrowSize * 0.25}px solid ${theme.palette.secondary.main}`,
    transform: `translate(-${(arrowSize * 0.25) / 2}px, -50%) rotateZ(45deg)`,
    zIndex: -1,
  },
  '&::after': {
    position: 'absolute',
    content: '""',
    left: 0,
    right: 0,
    bottom: 'calc(50% - 1px)',
    height: '2px',
    backgroundColor: theme.palette.secondary.main,
    zIndex: -1,
  },
}));
